import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PriceHelper } from '../helpers/PriceHelper';
import { BaseComponent } from '../classes/BaseComponent';

@Component({
  selector: 'app-child-singles',
  templateUrl: './child-singles.component.html',
  styleUrls: ['./child-singles.component.scss']
})
export class ChildSinglesComponent extends BaseComponent implements OnInit {

  @Input() singles;
  @Output() onSingleClicked = new EventEmitter();

  constructor() {
    super();
  }

  ngOnInit() {

  }

  singleClicked(e, single) {
    this.onSingleClicked.emit({event:e, single:single});
  }

  secondsToMinutes(seconds: number): string {
    if(!seconds) { return ""; }
    let mins: number = Math.floor(seconds / 60);
    let minsString: string = (mins < 10 )? "0"+mins : ""+mins;
    let secs: number = seconds % 60;
    let secsString: string = (secs < 10 )? "0"+secs : ""+secs;
    return minsString + ":" + secsString;
  }

  getPrice(price: number, currency: string) {
    return PriceHelper.formatPrice(price, currency);
  }

  priceClicked(single) {
    if(single){
      window.open(single.productPageUrl, "blank");
    }
  }

}
